// extracted by mini-css-extract-plugin
export default {"heading":"Nw-z","corrected":"Ow-z","redirectVerbiageContainer":"Pw-z","redirectVerbiageText":"Qw-z"};